import * as yup from 'yup';
import { timeOfDay, TranslateFn } from '../../../library/validationRules';
import ResourcesIds from '../../../resources/ResourcesIds';

/**
 * The two rules the API enforces, so a value this accepts is never one the API then
 * refuses: a real time of day, and at least one channel. Switching reminders off is exempt
 * from the second -- an admin turning the feature off should not have to pick a channel
 * they are not going to use.
 *
 * Stated per field rather than as one predicate, which is the point of the move: this panel
 * drew **no** field-level errors at all, so an admin with a half-typed time saw a dead Save
 * button and nothing else.
 */
export const createReminderSettingsSchema = (translate: TranslateFn) => yup.object({
    enabled: yup.boolean().defined(),
    sendTime: timeOfDay(translate, ResourcesIds.REMINDER_SETTINGS_SEND_TIME_INVALID),
    channels: yup.array().of(yup.string().defined()).defined()
        .when('enabled', {
            is: true,
            then: (field) => field.min(1,
                translate(ResourcesIds.REMINDER_SETTINGS_CHANNEL_REQUIRED)),
        }),
});
